import KendoDateRangePickerMixin from './KendoDateRangePickerMixin'

export default {
    name: 'kendo-daterangepicker',
    mixins: [ KendoDateRangePickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/index.js